<template>
  <div
    v-if="visible"
    id="sticky-bar"
    class="d-none d-md-block"
  >
    <table>
      <tr>
        <td
          :class="{active: tabActive == containers[0]}"
          @click="scrollTo(containers[0])"
        >
          Description
        </td>
        <td
          :class="{active: tabActive == containers[1]}"
          @click="scrollTo(containers[1])"
        >
          Détails du bien
        </td>
        <td
          :class="{active: tabActive == containers[2]}"
          @click="scrollTo(containers[2])"
        >
          Surfaces
        </td>
        <td
          :class="{active: tabActive == containers[3]}"
          @click="scrollTo(containers[3])"
        >
          Prestations
        </td>
        <td
          :class="{active: tabActive == containers[4]}"
          @click="scrollTo(containers[4])"
        >
          Efficacité énergétique
        </td>
        <td
          :class="{active: tabActive == containers[5]}"
          @click="scrollTo(containers[5])"
        >
          Informations légales
        </td>
        <td
          :class="{active: tabActive == containers[6]}"
          @click="scrollTo(containers[6])"
        >
          Proximités
        </td>
        <td
          :class="{active: tabActive == containers[7]}"
          @click="scrollTo(containers[7])"
        >
          Localisation
        </td>
      </tr>
    </table>

    <div
      id="progress-bar"
      :style="{width: pageProgress + '%'}"
    >
      &nbsp;
    </div>
  </div>
</template>

<script lang="ts" setup>
const visible = ref(false)
const containers = ref([
  'description-container',
  'details-container',
  'surfaces-container',
  'services-container',
  'energy-container',
  'legal-container',
  'proximities-container',
  'location-container'
])

const tabActive = ref('description-container')
const pageProgress = ref(0)

onMounted(() => {
  window.addEventListener('scroll', function () {
    const x = document.body.scrollTop || document.documentElement.scrollTop

    if (x > 630) { visible.value = true } else { visible.value = false }

    getPageProgress()
    // at each scroll, check all the container visibility in viewport, to set active tab
    containers.value.forEach(function (container) {
      if (isInViewport(container)) {
        tabActive.value = container
      }
    })
  })
})

function scrollTo (identifier: string) {
  const element = document.getElementById(identifier)
  element?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'nearest'
  })
}

function isInViewport (identifier: string) {
  const el = document.getElementById(identifier)

  const scroll = window.scrollY || window.pageYOffset
  const boundsTop = (el?.getBoundingClientRect()?.top ?? 0) + scroll

  const viewport = {
    top: scroll,
    bottom: scroll + window.innerHeight,
    quarter: scroll + window.innerHeight / 4
  }

  const bounds = {
    top: boundsTop,
    bottom: boundsTop + (el?.clientHeight ?? 0)
  }

  return bounds.top <= viewport.bottom && bounds.top >= viewport.top && bounds.top <= viewport.quarter
}

function getPageProgress () {
  const scroll = window.scrollY || window.pageYOffset
  const body = document.body
  const html = document.documentElement

  let height = Math.max(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight
  )

  height -= 700

  pageProgress.value = Math.round((scroll * 100) / height)
}
</script>

<style lang="scss" scoped>
#sticky-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  color: #1f1f1f;
  font-size: 14px;
  background: rgba($background, 90%);
  backdrop-filter: blur(20px);
  box-shadow: 0 1px 5px 0 rgba(204 204 204 / 100%);
  z-index: 9999;
}

table {
  margin: 0 auto;
  margin-top: 10px;

  td {
    padding: 10px;
    cursor: pointer;

    &.active {
      font-weight: normal;
    }
  }
}

#progress-bar {
  height: 3px;
  background: $purple;
}
</style>
